import { Component, OnInit } from '@angular/core';
import { InfiniteScrollCustomEvent, NavController, Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import { CommonService } from 'src/app/services/common.service';
import { NavigationExtras } from '@angular/router';
import { Checklist } from 'src/app/models/checklist.model';
import { constants } from 'src/app/utils/constants';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
  standalone: false
})
export class ChecklistComponent  implements OnInit {

  public isAndroid: boolean;
  public enableCreateButton: boolean = false;
  public checklist: any[] = [];
  public createButtonEnabled: boolean = false;
  public checkListUpdated: boolean = true;
  private isLoading: boolean = false;

  public isVisible: boolean[] = [];

  constructor(
    private platform: Platform,
    private commonService: CommonService,
    private navController: NavController,
  ) {
    this.initializeApp();
    this.isAndroid = this.platform.is('android');
  }

  async ngOnInit() {    
    this.isLoading = true;
    await this.commonService.clearAllLocalstorage();
    await this.commonService.getChecklistUpdate().subscribe(message => {
      this.checkListUpdated = message;
      this.generateChecklistItems();
    });

    await this.generateChecklistItems();
    await this.checklistValidation();
  }

  exitApp() {
    App.exitApp();
  }

  public async initializeApp() {
    await this.showIcon();
    await this.commonService.clearAllLocalstorage();
    await this.commonService.getSelectedItem('ACTIVITY'); 
    await this.commonService.getSelectedItem('ENTITY_TYPE');
    await this.commonService.getSelectedItem('ENTITY_SUBTYPE');
    await this.commonService.getSelectedItem('ADDRESS_TYPE');
    await this.commonService.getSelectedItem('PARTY_TYPE');
  }

  private async generateChecklistItems() {
    const checkList: any[] = await this.commonService.getAllItem();    
    this.checklist = [];
    this.checklist = [...checkList];
    // if (this.checkListUpdated) {
    // }
    // const count = this.checklist.length;
    // for (let i = 0; i < 10; i++) {
    //   if (checkList[count + i]) {
    //     this.checklist.push(checkList[count + i] as never);
    //     //console.log(checkList[count + i]);
    //   }
    // }
    this.sortChecklist();

    setTimeout(async () => {
      if (!this.checklist[0].referenceId) {
        let newItem = await this.commonService.getItem(this.checklist[0].itemId);
        this.checklist[0] = newItem;
      }
    }, 50000);
  }

  createNewCheckList() {
    this.commonService.pushCurrentTabPosition(0);
    this.commonService.clearAllLocalstorage();
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: constants.NEW,
          itemId: this.commonService.generateUUID()
        }
      },
      replaceUrl: true
    };

   this.navController.navigateBack([constants.PAGE.ORGANISATION], navigationExtras)
      .then(() => {
        location.reload();
      });
  }

  async getAllChecklist() {
    this.commonService.clearAllLocalstorage();
    this.checklist = await this.commonService.getAllItem();
  }
  
  viewDetails(checkItem: Checklist) {
    this.commonService.pushCurrentTabPosition(5);
    this.commonService.clearAllLocalstorage();
    this.commonService.setCurrentMode(constants.VIEW, checkItem);
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: constants.VIEW,
          itemId: checkItem.itemId
        }
      },
      replaceUrl: true
    };

    this.navController.navigateForward([constants.PAGE.ORGANISATION], navigationExtras).then(() => {
      location.reload();
    });    
  }

 editDetails(checkItem: Checklist) {
    this.commonService.pushCurrentTabPosition(5);
    this.commonService.clearAllLocalstorage();
    this.commonService.setCurrentMode(constants.EDIT, checkItem);
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: constants.EDIT,
          itemId: checkItem.itemId
        }
      },
      replaceUrl: true
    };

    this.navController.navigateForward([constants.PAGE.ORGANISATION], navigationExtras).then(() => {
      location.reload();
    });     
  }

  deleteDetails(checkItem: Checklist) {
    if (confirm("Are you sure, you want to delete this item?")) {
      if (checkItem.declaration.submissionDateTime == null 
        || checkItem.declaration.submissionDateTime == undefined) {
        this.commonService.removeItem(checkItem.itemId);
        this.commonService.clearAllLocalstorage();
        this.getAllChecklist();
        this.generateChecklistItems();
        this.checklistValidation();
        this.createButtonEnabled = false;
      } else {
        alert('You\'ve already submitted this data, so you can\'t delete this now.');
      }
    }
  }

  async processItem(idx: number) {
    try {
      this.isVisible[idx] = false;
      if (this.checklist[idx].referenceId == '') {
        this.checklist[idx].referenceId = this.checklist[idx].itemId.split('-').pop();
        let refId = await this.commonService.processChecklistItem(this.checklist[idx].itemId) as string;
        this.checklist[idx].referenceId = refId ? refId : this.checklist[idx].itemId.split('-').pop();
      }
    } catch (error) {
      alert(error);
    } finally {
      this.showIcon();
    }
  }

  checklistValidation() {
    if (this.checklist.length == 0) {
      this.createButtonEnabled = false;
    }

    for (let item of this.checklist) {
      if (!item.declaration) {
        this.createButtonEnabled = true;
      }

      if (!item.declaration.submissionDateTime) {
        this.createButtonEnabled = true;
      }
    }
  }

  showIcon() {
    setTimeout(() => {
      for (let i = 0; i < this.checklist.length; i++) {
        this.isVisible[i] = true;
      }
    }, 60000);
  }

  clearAllStorage() {
    if (confirm("Are you sure, you want to delete all list items")) {
      this.commonService.clearAllLocalstorage();
      window.location.reload();
    }
  }

  onIonInfinite(ev: InfiniteScrollCustomEvent) {
    if (this.isLoading) {
      ev.target.complete();
      return;
    }

    this.isLoading = true;

    this.generateChecklistItems();
    setTimeout(() => {
      ev.target.complete();
      this.isLoading = false;
    }, 500);
  }

  public trackById(index: number, checkItem: Checklist) {
    return checkItem.itemId;
  }

  public sortChecklist() {
    let currentItem: any = null;
    for (let i = 0; i < this.checklist.length; i++) {
      let item = this.checklist[i];
      if (this.commonService.checkIfNullOrUndefined(item.declaration.submissionDateTime)) {
        currentItem = item;
        this.checklist.splice(i, 1);
      }
    }

    this.checklist.sort((a: Checklist, b: Checklist) => {
      const dateASplitArray = a.declaration.submissionDateTime.split(' ');
      const dateADateOnly = dateASplitArray[0].split('-');
      const dateATimeOnly = dateASplitArray[1].split(':');

      const dateBSplitArray = b.declaration.submissionDateTime.split(' ');
      const dateBDateOnly = dateBSplitArray[0].split('-');
      const dateBTimeOnly = dateBSplitArray[1].split(':');


      const dateA = new Date();
      const dateB = new Date();

      dateA.setDate(dateADateOnly[0]);
      dateA.setMonth(dateADateOnly[1] - 1);
      dateA.setFullYear(dateADateOnly[2]);
      dateA.setHours(dateATimeOnly[0]);
      dateA.setMinutes(dateATimeOnly[1]);

      dateB.setDate(dateBDateOnly[0]);
      dateB.setMonth(dateBDateOnly[1] - 1);
      dateB.setFullYear(dateBDateOnly[2]);
      dateB.setHours(dateBTimeOnly[0]);
      dateB.setMinutes(dateBTimeOnly[1]);

      if (dateA < dateB) {
        return 1;
      } else if (dateB < dateA) {
        return -1;
      }
      return 0;
    });

    if (currentItem && currentItem != null) {
      this.checklist.splice(0, 0, currentItem);
    }
    this.isLoading = false;
  }

}
